import router from './router'

export default {
	moduleName: 'sensitiveWord',
	router
}



// WEBPACK FOOTER //
// ./src/core/modules/sensitiveWord/index.js